<template>
  <div>
    <v-menu
        open-on-hover
        top
        offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            small
            fab
            text
            v-bind="attrs"
            v-on="on"
        >
          <img :src="selected && selected.image"/>
        </v-btn>
      </template>

      <v-list>
        <v-list-item
            v-for="(item, index) in sorted"
            :key="index"
            class="pointer"
            @click="changeTo(item)"
        >
          <v-list-item-avatar tile size="16"><v-img :src="item.image"/></v-list-item-avatar>
          <v-list-item-action >{{ item.name }}</v-list-item-action>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import {mapFields} from "vuex-map-fields";

export default {
  name: "LanguageSwitcher",
  data: () => ({
    selected: null,
  }),
  computed:{
    ...mapFields("site", ["languages"]),
    sorted() {
      return this.languages.sort((a, b) => {
        const nameA = a.name.toLowerCase();
        const nameB = b.name.toLowerCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    },
  },
  mounted() {
    let currentFlag = this.languages.find(item=>item.locale === this.$i18n.locale)
    if(currentFlag){
      this.selected = currentFlag;
    }
  },
  methods:{
    changeTo(to){
      this.$i18n.locale = to.locale;
      this.selected = to;
    }
  }
}
</script>

<style scoped>

</style>